var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.7037 38.2382C89.1194 47.2702 88.26 56.8657 84.2778 65.3247C80.2955 73.7836 73.4476 80.5599 64.9472 84.453C56.4469 88.346 46.8429 89.1045 37.8368 86.594C28.8307 84.0835 21.004 78.4661 15.7434 70.737C10.4827 63.008 8.1278 53.6664 9.09579 44.3672C10.0638 35.068 14.2922 26.4116 21.0319 19.9317C27.7716 13.4519 36.5875 9.56688 45.9175 8.96506C55.2476 8.36324 64.4895 11.0835 72.0058 16.6437L68.2294 21.7487C61.9188 17.0804 54.1595 14.7966 46.3263 15.3019C38.493 15.8071 31.0914 19.0689 25.4329 24.5092C19.7744 29.9495 16.2243 37.2172 15.4116 45.0246C14.5989 52.832 16.5761 60.675 20.9928 67.1641C25.4095 73.6532 31.9806 78.3695 39.5419 80.4772C47.1032 82.585 55.1665 81.9482 62.3032 78.6797C69.4399 75.4112 75.1892 69.722 78.5326 62.62C81.876 55.5181 82.5975 47.4619 80.5694 39.8789L86.7037 38.2382Z",
    fill: "#00BF71"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_629_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.377 38.5349L44.0645 59.5349L34.377 49.9895",
    stroke: "#00BF71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_629_1007",
    x: 29.377,
    y: 37.5349,
    width: 41,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.74902 0 0 0 0 0.443137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_629_1007"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_629_1007",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.c1138eb1f304dff04057437be28ea405.svg";
export { ForwardRef as ReactComponent };